import { Eye } from "lucide-react";
import { useAuth } from "../auth/AuthContext";

/** Fixed amber 40 px strip while a Superadmin is impersonating (§2.2, §6.4). It sits above
 * the shell in the page flow, so it never covers content. */
export function ImpersonationBanner() {
  const { impersonation, exitImpersonation } = useAuth();
  if (!impersonation) return null;
  return (
    <div
      role="region"
      aria-label="Impersonation"
      className="no-print flex h-10 shrink-0 items-center justify-center gap-3 border-b border-warning/30 bg-warning-tint px-4 text-sm font-semibold text-warning"
    >
      <Eye className="h-4 w-4 shrink-0" aria-hidden="true" />
      <span className="truncate">
        Viewing as {impersonation.user.fullName} — impersonating on behalf of{" "}
        {impersonation.actorName}
      </span>
      <button
        type="button"
        onClick={exitImpersonation}
        className="shrink-0 font-bold underline underline-offset-2 hover:no-underline"
      >
        Exit impersonation
      </button>
    </div>
  );
}
